<!-- Page content -->
<div class="page-content bg-dark login_page_content">

	<!-- Main content -->
	<div class="content-wrapper">

		<!-- Inner content -->
		<div class="content-inner">

			<!-- Content area -->
			<div class="content d-flex justify-content-center align-items-center">

				<!-- Login card -->
				<form class="login-form" name="loginForm" #loginForm="ngForm" (ngSubmit)="login()">
					<div class="card mb-0">
						<div class="card-body">
							<div class="text-center mb-3">
								<div class="d-inline-flex align-items-center justify-content-center mb-4 mt-2">
									 <img src="images/iit-madras-logo1.png" class="h-80px" alt=""> 
									 <!-- <img src="images/Login_image.png" alt="MANGO Logo" class="login-image" > -->
								</div>
								<h5 class="mb-0">Login to your account</h5>
								<span class="d-block text-muted">Enter your credentials below</span>
							</div>

							<div class="mb-3">
								<label class="form-label">Email</label>
								<div class="form-control-feedback form-control-feedback-start">
									<input type="text" class="form-control" appLowercaseInput placeholder="Enter your email" [(ngModel)]="email" id="user-name" name="username" required #username="ngModel">
									<div class="form-control-feedback-icon">
										<i class="ph-user-circle text-muted"></i>
									</div>
								</div>
								<div [hidden]="!(username.dirty && username.invalid || username.touched)">
									<div class="form-text text-danger" [hidden]="!username.errors?.['required']">
										<i class="ph-x-circle me-1"></i> Username is required.
									</div>
								</div>
							</div>

							<div class="mb-3">
								<label class="form-label">Password</label>
								<div class="form-control-feedback form-control-feedback-start">
									<input type="password" class="form-control" placeholder="Enter your password" [(ngModel)]="password" id="user-password" name="pwd" required #pwd="ngModel"> 
									<div class="form-control-feedback-icon">
										<i class="ph-lock text-muted"></i>
									</div>
								</div>
								<div [hidden]="!(pwd.dirty && pwd.invalid || pwd.touched)">
									<div class="form-text text-danger" [hidden]="!pwd.errors?.['required']">
										<i class="ph-x-circle me-1"></i> Password is required.
									</div>
								</div>
							</div>

							<div class="d-flex align-items-center mb-3">
								<label class="form-check">
									<input type="checkbox" name="remember" class="form-check-input" checked>
									<span class="form-check-label">Remember</span>
								</label>

								<a href="/forgot-pwd" class="ms-auto">Forgot password?</a>
							</div>

							<div class="mb-3">
								<button type="submit" [disabled]="loginForm.form.invalid || !loginForm.form.dirty" class="btn btn-primary w-100">Sign in</button>
							</div>

							<div class="alert alert-danger alert-icon-start alert-dismissible fade show" *ngIf="authenticationError">
								<span class="alert-icon bg-danger text-white">
									<i class="ph-x-circle"></i>
								</span>
								<span class="fw-semibold">Oh snap!</span> You have entered an invalid username or password.
								<button type="button" class="btn-close" data-bs-dismiss="alert"></button>
						    </div>

							<div class="alert alert-danger alert-icon-start alert-dismissible fade show" *ngIf="accessExpired">
								<span class="alert-icon bg-danger text-white">
									<i class="ph-warning"></i>
								</span>
								<span class="fw-semibold">Access expired!</span> {{ accessExpiredMessage }}
								<button type="button" class="btn-close" data-bs-dismiss="alert"></button>
						    </div>

							<!-- <div class="text-center text-muted content-divider mb-3">
								<span class="px-2">or sign in with</span>
							</div>

							<div class="text-center mb-3">
								<button type="button" class="btn btn-outline-primary btn-icon rounded-pill border-width-2"><i class="ph-facebook-logo"></i></button>
								<button type="button" class="btn btn-outline-pink btn-icon rounded-pill border-width-2 ms-2"><i class="ph-dribbble-logo"></i></button>
								<button type="button" class="btn btn-outline-secondary btn-icon rounded-pill border-width-2 ms-2"><i class="ph-github-logo"></i></button>
								<button type="button" class="btn btn-outline-info btn-icon rounded-pill border-width-2 ms-2"><i class="ph-twitter-logo"></i></button>
							</div> -->
							
							<div class="text-center text-muted content-divider mb-3">
								<span class="px-2">Don't have an account?</span>
							</div>

							<div class="mb-3">
								<a href="/signup" class="btn btn-light w-100">Sign up</a>
							</div>

							<span class="form-text text-center text-muted">By continuing, you're confirming that you've read our <a href="#">Terms &amp; Conditions</a> and <a href="#">Cookie Policy</a></span>
						</div>
					</div>
				</form>
				<!-- /login card -->

			</div>
			<!-- /content area -->

		</div>
		<!-- /inner content -->

	</div>
	<!-- /main content -->

	<!-- Info Icon -->
	 
	

	<!-- Version Popup -->
	
</div>
<!-- /page content -->
